import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setOnNoActivePlan } from '../services/apiServices';
import { routes } from '../utils/routes.config';

/**
 * PlanGuard: Sets up global handler for 403 NO_ACTIVE_PLAN.
 * When any API returns this, redirect store owners to plan selection.
 */
const PlanGuard = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    setOnNoActivePlan(() => navigate(routes.SELECT_PLAN));
    return () => setOnNoActivePlan(null);
  }, [navigate]);

  return children;
};

export default PlanGuard;
